import useSelectedInstitution from '../institutions/useSelectedInstitution';
import useUserDetails from './useUserDetails';

export default () => {
  const { userId } = useUserDetails();
  const { mainUser } = useSelectedInstitution();

  return mainUser?.id === userId;
};
